export const FOCUSABLE_TOOLTIP_OPEN = 'focusableTooltipOpen';
export const FOCUSABLE_TOOLTIP_CLOSE = 'focusableTooltipClose';
